import {
  useParseContentForQuestionCreation,
  type UseParseContentForSingleQuestionInput,
} from '../use-parse-content-for-question-creation';

export function useParseContentForSingleQuestionCreation(
  params: UseParseContentForSingleQuestionInput,
) {
  const { parseContentForDisplay } = useParseContentForQuestionCreation(params);

  return { parseSingleQuestionContent: parseContentForDisplay };
}
